import { Position, Toaster } from '@blueprintjs/core'
import { sidebarDirection } from '../../helper/configs'
import { globalOnDemandVars } from '../../helper/context'
import { defer } from 'lodash'

/** Singleton toaster instance. Create separate instances for different options. */
// const RightToaster = !Toaster ? null : Toaster.create({
//   position: Position.BOTTOM_RIGHT,
//   canEscapeKeyClear: false
//   // , className:
// })
// const LeftToaster = !Toaster ? null : Toaster.create({
//   position: Position.BOTTOM_LEFT,
//   canEscapeKeyClear: false
//   // , className:
// })

//  Toaster 가 처음에 안불러와지고 그래서 Toaster가 falsy면 defer후에 다시 시도하는거로 함
let RightToaster, LeftToaster
if (Toaster) {
  RightToaster = Toaster.create({
    position: Position.TOP_RIGHT,
    canEscapeKeyClear: false
    // , className:
  })
  LeftToaster = Toaster.create({
    position: Position.TOP_LEFT,
    canEscapeKeyClear: false
    // , className:
  })
} else {
  defer(() => {
    if (Toaster) {
      RightToaster = Toaster.create({
        position: Position.TOP_RIGHT,
        canEscapeKeyClear: false
        // , className:
      })
      LeftToaster = Toaster.create({
        position: Position.TOP_LEFT,
        canEscapeKeyClear: false
        // , className:
      })
    } else {
      defer(() => {
        RightToaster = Toaster.create({
          position: Position.TOP_RIGHT,
          canEscapeKeyClear: false
          // , className:
        })
        LeftToaster = Toaster.create({
          position: Position.TOP_LEFT,
          canEscapeKeyClear: false
          // , className:
        })
      })
    }
  })
}

function showToast (direction, props) {
  if (direction === 'right') {
    RightToaster.show(props)
  }
  if (direction === 'left') {
    LeftToaster.show(props)
  }
}

function showToastByMenuDirectionBase (props) {
  if (sidebarDirection === 'right') {
    showToast('left', props)
  }
  if (sidebarDirection === 'left') {
    showToast('right', props)
  }
}

export { showToast, showToastByMenuDirectionBase }
